// src/lib/roles.js
// Add new roles here. Each role is a self-contained entity.
// Set logo to a URL string or null to use the initials badge.

export const ROLES = [
  {
    id: "pcc",
    name: "Paradise Creek Counseling",
    shortName: "PCC",
    initials: "PC",
    logo: null,           // e.g. "/logos/pcc-logo.png"
    accent: "#2DD4BF",
    accentDark: "#0F766E",
    accentBg: "rgba(45,212,191,0.1)",
    description: "Behavioral health private practice"
  },
  {
    id: "pyha",
    name: "Paradise Valley Hockey Association",
    shortName: "PYHA",
    initials: "PY",
    logo: null,
    accent: "#0EA5E9",
    accentDark: "#0369A1",
    accentBg: "rgba(14,165,233,0.1)",
    description: "Youth hockey association"
  },
  {
    id: "pcct",
    name: "Paradise Creek Clinical Technology",
    shortName: "PCCT",
    initials: "CT",
    logo: null,
    accent: "#F59E0B",
    accentDark: "#B45309",
    accentBg: "rgba(245,158,11,0.1)",
    description: "Clinical technology products"
  },
];

export const CATEGORIES = {
  pcc: [
    { id: "billing",       label: "Billing & AR",       color: "#6366F1" },
    { id: "credentialing", label: "Credentialing",       color: "#8B5CF6" },
    { id: "hr",            label: "HR & Employment",     color: "#EC4899" },
    { id: "onboarding",    label: "Provider Onboarding", color: "#14B8A6" },
    { id: "compliance",    label: "Compliance",          color: "#F97316" },
    { id: "vendors",       label: "Bills & Vendors",     color: "#64748B" },
    { id: "general",       label: "General",             color: "#94A3B8" },
  ],
  pyha: [
    { id: "pyha_ops",      label: "Operations",          color: "#0EA5E9" },
    { id: "pyha_finance",  label: "Finance & Insurance", color: "#6366F1" },
    { id: "pyha_legal",    label: "Legal & Compliance",  color: "#F97316" },
    { id: "pyha_programs", label: "Programs & Ice",      color: "#2DD4BF" },
    { id: "pyha_general",  label: "General",             color: "#94A3B8" },
  ],
  pcct: [
    { id: "pcct_legal",    label: "Legal & Entity",      color: "#F97316" },
    { id: "pcct_product",  label: "Product Milestones",  color: "#F59E0B" },
    { id: "pcct_cx",       label: "Customer Relations",  color: "#2DD4BF" },
    { id: "pcct_saas",     label: "SaaS Compliance",     color: "#8B5CF6" },
    { id: "pcct_finance",  label: "Finance & Banking",   color: "#64748B" },
  ],
};

export const RECURRENCE_OPTIONS = [
  { value: "none",      label: "No recurrence" },
  { value: "weekly",    label: "Weekly" },
  { value: "biweekly",  label: "Every 2 weeks" },
  { value: "monthly",   label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "annually",  label: "Annually" },
];

export function getCategoryColor(roleId, categoryId) {
  return (CATEGORIES[roleId] || []).find(c => c.id === categoryId)?.color || "#64748B";
}
export function getCategoryLabel(roleId, categoryId) {
  return (CATEGORIES[roleId] || []).find(c => c.id === categoryId)?.label || categoryId;
}
export function getRole(roleId) {
  return ROLES.find(r => r.id === roleId) || ROLES[0];
}
